import { createServerFn } from '@tanstack/react-start';

import { toPublicWriting } from '@/content/schemas';

import { isWritingCategory } from './categories';
import { selectRelatedWriting } from './selectors';

export const loadPublishedWriting = createServerFn({ method: 'GET' }).handler(
  async () => {
    const { getPublishedWriting, getPublishedCategories } = await import(
      './writing.server'
    );
    return {
      posts: getPublishedWriting(),
      activeCategories: getPublishedCategories(),
    };
  }
);

export const loadWritingCategory = createServerFn({ method: 'GET' })
  .validator((category: string) => category)
  .handler(async ({ data: category }) => {
    if (!isWritingCategory(category)) {
      return null;
    }

    const {
      getPublishedCategories,
      getPublishedWriting,
      getWritingByCategory,
    } = await import('./writing.server');

    const activeCategories = getPublishedCategories();
    if (!activeCategories.includes(category)) {
      return null;
    }

    return {
      category,
      posts: getWritingByCategory(category),
      activeCategories,
      allPosts: getPublishedWriting(),
    };
  });

export const loadWritingArticle = createServerFn({ method: 'GET' })
  .validator((slug: string) => slug)
  .handler(async ({ data: slug }) => {
    const { getPublishedWritingRecordBySlug } = await import(
      './writing.server'
    );
    const { renderWritingMdxHtmlFromSource } = await import(
      './compile-mdx.server'
    );

    const record = getPublishedWritingRecordBySlug(slug);
    if (!record?.sourcePath) {
      return null;
    }

    const article = toPublicWriting(record);
    const bodyHtml = await renderWritingMdxHtmlFromSource(
      process.cwd(),
      record.sourcePath
    );
    const related = selectRelatedWriting(
      (await import('./writing.server')).getPublishedWriting(),
      slug,
      article.category
    );

    return { article, bodyHtml, related };
  });
